// @flow
import { useMemo } from "react";
import * as React from 'react';
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { normalizeGreek } from "../../../helpers/normalizeGreek";
import { useTranslation } from "react-i18next";
import { FormControl } from "@mui/material";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import { AuthenticatedLink } from "../../../components/general/authenticatedLink/authenticatedLink";
import { API } from "../../../helpers/constants";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers-pro";
import TextField from "@mui/material/TextField";
import { formatDate } from "../../../helpers/date";
import useUserData from "../../../hooks/user/useUserData";

type Props = {};

export const DownloadExhibitorLogos = (props: Props) => {
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const { dateFormat } = useUserData()
	const { open, handleCloseDownloadExhibitorLogos, exhibitionId, type } = props
	const [value, setValue] = React.useState([null, null])
	const updateDates = (newV, index) => {
		const newValue = value.map((v, j) => j === index ? newV : v)
		setValue(newValue)
	}
	const url = useMemo(() => (
		type === 'catalogueLogo' ? 'exhibitor/get-catalogue-logos' : 'exhibitor/get-logos'
	), [type])
	
	return (
		<React.Fragment>
			<Box onClick={(e) => e.stopPropagation()}>
				<Popover
					disableRestoreFocus
					onClose={() => {
						setValue([null, null])
						handleCloseDownloadExhibitorLogos()
					}}
					open={Boolean(open)}
					anchorEl={open}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
				>
					<Stack
						direction={'column'}
						minHeight={'240px'}
						maxWidth={'380px'}
						justifyContent={'space-around'}
						p={2}
						width={'100%'}
					>
						<Typography
							variant="body"
							color={'textSecondary'}
						>
							{t('Select date filters optionally and press DOWNLOAD.')}
						</Typography>
						<FormControl sx={{ mb: 1, mt: 1 }}>
							<DatePicker
								label={t('Upload Date From')}
								value={value[0]}
								format={dateFormat}
								onChange={(newValue) => {
									updateDates(newValue, 0);
								}}
								slots={{ textField: TextField }}
								slotProps={{
									textField: { size: 'small', variant: 'filled' },
								}}
							/>
							<Box sx={{ my: 1 }}/>
							<DatePicker
								size={"small"}
								format={dateFormat}
								label={t('Upload Date To')}
								value={value[1]}
								onChange={(newValue) => {
									updateDates(newValue, 1);
								}}
								slots={{ textField: TextField }}
								slotProps={{
									textField: { size: 'small', variant: 'filled' },
								}}
							/>
						</FormControl>
						<AuthenticatedLink
							filename={'export'}
							url={`${API}/en/${url}/${exhibitionId}?${value[0] && value[0]?.isValid() ? '&UploadDateFrom=' + formatDate(value[0], formatDate.formatTypes.DATE_ONLY_FILTER) : ''}${value[1] && value[1]?.isValid() ? '&UploadDateTo=' + formatDate(value[1], formatDate.formatTypes.DATE_ONLY_FILTER) : ''}`}
						>
							<Button
								variant={"outlined"}
								size={"small"}
								color={'highlight'}
								fullWidth
							>
								{normalizeGreek(t('Download'))}
							</Button>
						</AuthenticatedLink>
					</Stack>
				</Popover>
			</Box>
		</React.Fragment>
	);
};